import React from 'react';
import { AppBar, useTranslate, ToggleThemeButton } from 'react-admin';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import LocaleSwitcher from '../Translation/LocaleSwitcher';
import { createTheme } from '@mui/system';
import appTheme from "../theme";
import appThemeDark from "../themeDark";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

const Title = styled(Typography)({
  flex: 1,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

const Spacer = styled('div')({
  flex: 1,
});

const Section = styled('span')({
  display: 'block',
  fontWeight: '',
  fontSize: '1.4em',
  color: '#FFFFFF',
  paddingRight: '30px',
  paddingLeft: '30px',
  paddingTop: '5px',
  paddingBottom: '5px',
  textDecoration: 'none',
  fontFamily: ['Helvetica', 'Arial', 'Segoe UI'].join(','),
});

const DarkTheme = createTheme({
  palette: { mode: 'dark' },
});

const VeroAppBar = ({ ...props }) => {
  const translate = useTranslate();
  const isAuthenticated = useIsAuthenticated();

  return (
    <AppBar {...props}>
      <Title variant="title" color="inherit" id="react-admin-title" />
      <div>
        <h2 style={{ fontSize: "inherit" }}>{translate('myroot.Vero')}</h2>
      </div>
      <Spacer />
      <LocaleSwitcher />
      <ToggleThemeButton lightTheme={appTheme} darkTheme={appThemeDark} />
      {isAuthenticated ? <SignOutButton /> : <SignInButton />}
    </AppBar>
  );
};

export default VeroAppBar;
